import React from 'react';
import { SEO } from '../components/shared/SEO';

export const ServiciosScreen = () => {
  return (
    <div className="section-padding container">
      <SEO
        title="Servicios Contables e Impositivos en Corrientes"
        description="Servicios contables integrales en Corrientes Capital: Liquidación de sueldos, impuestos (IVA, Ganancias, Ingresos Brutos DGR), Monotributo y Balances comerciales."
        keywords="servicios contables corrientes, liquidacion de sueldos corrientes, liquidacion de impuestos corrientes, monotributo corrientes, balances contables corrientes"
        url="https://rymcontable.com.ar/servicios"
      />
      <h2 className="text-center">Soluciones de Alto Impacto</h2>
      <p className="text-center" style={{ maxWidth: '700px', margin: '0 auto 3rem' }}>
        Estructuramos nuestros servicios en tres unidades de negocio especializadas para responder con precisión a la etapa y necesidad de su organización en Corrientes y la región.
      </p>

      <div className="services-grid">
        {/* Unidad Corporativa */}
        <div className="service-card">
          <h3>Unidad Corporativa</h3>
          <p>Enfocado a empresas consolidadas que buscan delegar el 100% de su carga administrativa y fiscal.</p>
          <ul>
            <li>Liquidación de Sueldos y Cargas Sociales</li>
            <li>Liquidación de IVA y Ganancias</li>
            <li>Auditorías y Balances</li>
            <li>Planificación Fiscal Estratégica</li>
          </ul>
        </div>

        {/* Unidad Emprendedora */}
        <div className="service-card">
          <h3>Unidad Emprendedora</h3>
          <p>Para quienes están creciendo y necesitan orden para escalar su negocio.</p>
          <ul>
            <li>Gestión de Monotributo y Recategorizaciones</li>
            <li>Altas y Bajas en AFIP y Rentas</li>
            <li>Facturación y Control de Gastos</li>
            <li>Asesoramiento inicial para PyMEs</li>
          </ul>
        </div>

        {/* Unidad Legal & Laboral */}
        <div className="service-card">
          <h3>Unidad Legal y Laboral</h3>
          <p>Soluciones específicas para empleadores y trámites especiales.</p>
          <ul>
            <li>Registración de Casas Particulares</li>
            <li>Certificaciones de Ingresos</li>
            <li>Trámites y Habilitaciones Especiales</li>
            <li>Consultoría Laboral Preventiva</li>
          </ul>
        </div>
      </div>
    </div>
  );
};
